(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taglia-waitlist"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async function (event) {
    var form = event.target.closest && event.target.closest('.taglia-wl__form');
    if (!form) return;
    event.preventDefault();
    var root = form.closest('.taglia-wl');
    var input = form.querySelector('input[type=email]');
    var button = form.querySelector('button');
    var msg = root.querySelector('.taglia-wl__msg');
    var email = (input.value || '').trim();
    var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    msg.removeAttribute('data-state');
    if (!valid) {
      input.setAttribute('aria-invalid', 'true');
      msg.setAttribute('data-state', 'error');
      msg.textContent = 'Please enter a valid email address.';
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    button.disabled = true;
    msg.textContent = '';
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: root.dataset.source || 'Apres Awaits waitlist',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  apres_awaits_waitlist: true,
                  apres_awaits_waitlist_joined: new Date().toISOString()
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: root.dataset.list } } }
      }
    };
    try {
      var res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('status ' + res.status);
      form.hidden = true;
      msg.textContent = msg.dataset.success;
    } catch (err) {
      msg.setAttribute('data-state', 'error');
      msg.textContent = 'Something went wrong. Please try again in a moment.';
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
